import CreativitySection from "../components/Sections/CreativitySection";

export default function CreativityPage() {
  return (
      <>
          <CreativitySection />
  
      </>
  )
  
}
